<template>
  <v-app>
    <LoadingScreen :loading="loading" />
    <Homelinks v-if="success && isAdmin" />
    <div
      id="firebaseui-auth-container"
      style="display: none"
      v-else-if="!success && isAdmin"
    ></div>
    <router-view v-else />

    <!-- <Login v-else /> -->
  </v-app>
</template>

<script>
// import Login from "./components/Login";
import LoadingScreen from "./components/commons/LoadingScreen";
import Homelinks from "./components/Homelinks";
import {
  auth,
  userCollection,
  // bearer,
  firebaseui,
  signInWithEmail,
  // ipAddress,
} from "./firebase";
// import Axios from "axios";
// import LeftPanel from './components/LeftPanel';
// import Footer from './components/Footer';
// import Header from './components/Header';

export default {
  name: "App",
  created() {
    var urlIsAdmin = document.location.href.includes("/my");
    if (urlIsAdmin) {
      this.isAdmin = true;
    } else {
      this.isAdmin = false;
    }

    let _this = this;
    auth.onAuthStateChanged((user) => {
      if (user) {
        _this.user = user;
        _this.loading = true;

        userCollection
          .doc(user.uid)
          .get()
          .then((doc) => {
            if (doc.exists) {
              if (
                doc.data().roles["admin"] ||
                doc.data().roles["my_app_admin"]
              ) {
                _this.$store.commit(
                  "setUser",
                  JSON.parse(JSON.stringify(doc.data()))
                );
                _this.success = true;
                _this.loading = false;
              } else {
                auth.signOut();
                _this.success = false;
                _this.loading = false;
                alert("Unauthorised");
              }
            }
          })
          .catch((err) => console.error(err));
      } else {
        this.initiateloginUI();
        document.getElementById("firebaseui-auth-container").style.display =
          "block";
        this.success = false;
      }
    });
  },
  data() {
    return {
      success: localStorage.getItem("isSuccess"),
      loading: false,
      user: {},
      proceedtologin: false,
      bearer_token: "",
      isAdmin: false,
    };
  },

  updated() {},

  computed: {
    currentView() {
      return this.$store.state.currentView;
    },
  },

  components: {
    // 'left-panel' : LeftPanel,
    //  Footer,
    //  Header
    // Login,
    LoadingScreen,
    Homelinks,
  },

  watch: {
    currentView: function (val) {
      this.$router.push({ name: val }).catch(() => {});
    },
  },

  methods: {
    goTo(view) {
      this.$store.dispatch("loadView", view);
    },
    initiateloginUI() {
      auth.signOut();
      // Initialize the FirebaseUI Widget using Firebase.
      const ui = new firebaseui.auth.AuthUI(auth);
      let _this = this;
      const uiConfig = {
        callbacks: {
          signInSuccessWithAuthResult: function () {
            // User successfully signed in.
            // Return type determines whether we continue the redirect automatically
            // or whether we leave that to developer to handle.
            return true;
          },
          uiShown: function () {
            // The widget is rendered.
            // Hide the loader.
            _this.loading = false;
          },
        },
        // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
        signInFlow: "popup",
        signInSuccessUrl: "/my/dashboard",
        signInOptions: [
          // Leave the lines as is for the providers you want to offer your users.
          signInWithEmail,
        ],
        // Terms of service url.
        tosUrl: "https://www.maxi-cash.com.my/info/terms-of-use/",
        // Privacy policy url.
        privacyPolicyUrl: "https://www.maxi-cash.com.my/info/privacy-policy/",
      };
      ui.start("#firebaseui-auth-container", uiConfig);
    },
    // proceedlogin() {
    //   document.getElementById("firebaseui-auth-container").style.display =
    //     "none";
    //   this.loading = false;
    //   this.success = true;
    //   bearer
    //     .doc("access_bearer_token")
    //     .get()
    //     .then((doc) => {
    //       this.bearer_token = doc.data().token;
    //     });
    // },
  },
};
</script>

<style>
#content-wrapper {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #212121;
  font-weight: 300;
  padding: 20px 20px 100px 20px;
}

.dialog-screen-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.575);

  display: flex;
  justify-content: center;
  align-items: center;
}

/* common css */
.pt-0 {
  padding-top: 0 !important;
}

.p-0 {
  padding: 0 !important;
}

/* Page headers */
.header.text-left {
  font-size: 26px;
  font-weight: normal;
}

/* Filter and create buttons */

.action-buttons {
  display: flex;
  justify-content: flex-end;
}

.action-buttons button {
  color: white !important;
  letter-spacing: normal;
  text-transform: none;
}

.action-buttons .filter-btn {
  margin-right: 20px;
}

@media only screen and (max-width: 959px) {
  .action-buttons {
    justify-content: flex-start;
  }
}
</style>
